import { render } from "./ElectionPolicyControl.vue?vue&type=template&id=4cc4773b"
import script from "./ElectionPolicyControl.vue?vue&type=script&lang=js"
export * from "./ElectionPolicyControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__